"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PluginResource = void 0;
var tslib_1 = require("tslib");
var basePlugin_1 = tslib_1.__importDefault(require("../base/basePlugin"));
var typings_1 = require("../typings");
var logger_1 = tslib_1.__importDefault(require("../utils/logger"));
var util_1 = require("../utils/util");
var const_1 = require("../utils/const");
var RESOURCE_TYPE = ['link', 'css', 'script', 'img'];
var defaultOption = {
    disable: false,
    sampleRate: 20,
    ignoreList: [],
};
var PluginResource = /** @class */ (function (_super) {
    tslib_1.__extends(PluginResource, _super);
    function PluginResource(queue, config) {
        if (config === void 0) { config = defaultOption; }
        var _this = _super.call(this, queue, config) || this;
        _this.name = PluginResource.id;
        _this.config = util_1.extend(defaultOption, _this.config);
        return _this;
    }
    PluginResource.prototype.parsePerformanceResource = function () {
        if (!util_1.canUseGetEntriesByType())
            return false;
        var resourceEntries = window.performance.getEntriesByType('resource');
        this.handleResourceEntry(resourceEntries);
    };
    PluginResource.prototype.handleResourceEntry = function (entries) {
        var _this = this;
        var filterdEntries = this.filter(entries);
        if (!(filterdEntries === null || filterdEntries === void 0 ? void 0 : filterdEntries.length))
            return false;
        filterdEntries.forEach(function (entry) {
            var type = _this.parseResourceType(entry.name);
            _this.addData({
                type: const_1.METRICS_RESOURCE,
                ts: Date.now(),
                value: (entry === null || entry === void 0 ? void 0 : entry.duration) || 0,
                tags: {
                    resourceType: type,
                    resourceUrl: entry === null || entry === void 0 ? void 0 : entry.name,
                    responsetime: (entry === null || entry === void 0 ? void 0 : entry.duration) || 0,
                    responsebyte: (entry === null || entry === void 0 ? void 0 : entry.transferSize) || 0,
                    protocol: entry === null || entry === void 0 ? void 0 : entry.nextHopProtocol,
                },
            });
        });
    };
    PluginResource.prototype.filter = function (entries) {
        var _this = this;
        return entries.filter(function (entry) {
            // 指定 entry 类型是 resource entry
            if (RESOURCE_TYPE.indexOf(entry === null || entry === void 0 ? void 0 : entry.initiatorType) === -1)
                return false;
            // 过滤用户配置的资源filter
            return _this.filterResource(entry === null || entry === void 0 ? void 0 : entry.name);
        });
    };
    PluginResource.prototype.handleResourceError = function (event) {
        try {
            var target = (event.target || event.srcElement);
            var isElementTarget = target instanceof HTMLScriptElement ||
                target instanceof HTMLLinkElement ||
                target instanceof HTMLImageElement;
            if (!isElementTarget)
                return false;
            if (target) {
                var resourceUrl = target.src || target.href;
                var resourceType = target.nodeName || '';
                if (!resourceUrl)
                    return false;
                if (this.filterResource(resourceUrl)) {
                    this.addData({
                        type: const_1.METRICS_RESOURCE_ERROR,
                        ts: Date.now(),
                        value: 1,
                        tags: {
                            resourceUrl: resourceUrl,
                            resourceType: resourceType,
                        },
                    });
                }
            }
        }
        catch (error) {
            logger_1.default.log('监听资源加载失败错误', error);
        }
    };
    PluginResource.prototype.filterResource = function (url) {
        return this.config.ignoreList.every(function (regStr) {
            try {
                var reg = new RegExp(regStr);
                if (reg.test(url)) {
                    return false;
                }
                return true;
            }
            catch (error) {
                logger_1.default.log('过滤资源url异常', error);
                return false;
            }
        });
    };
    PluginResource.prototype.init = function () {
        var _this = this;
        if (document && document.readyState === 'complete') {
            this.parsePerformanceResource();
            this.observeResourceTiming();
        }
        else {
            window.addEventListener('load', function () {
                _this.parsePerformanceResource();
                _this.observeResourceTiming();
            });
        }
        window.addEventListener('error', function (event) {
            if (event) {
                _this.handleResourceError(event);
            }
        }, true);
    };
    PluginResource.prototype.observeResourceTiming = function () {
        var _this = this;
        // 动态监听资源请求
        util_1.addPerformanceObserver('resource', function (list) {
            try {
                var entries = list.getEntriesByType('resource');
                _this.handleResourceEntry(entries);
            }
            catch (e) {
                logger_1.default.log('动态监听资源加载失败', e);
            }
        });
    };
    /**
     * 根据资源url后缀判断资源类型
     * 不可以通过 performance api 返回的 initialType 并不准确 eg：css 中 background-img 触发的资源下载 initialType 为 css
     * @param url 资源url
     */
    PluginResource.prototype.parseResourceType = function (url) {
        if (const_1.imgPattern.test(url) || /\.(png|jpg|jpeg|gif|webp|ico|bmp|tiff|svg)@/i.test(url)) {
            return 'img';
        }
        else if (const_1.cssPattern.test(url)) {
            return 'css';
        }
        else if (const_1.jsPattern.test(url)) {
            return 'script';
        }
        return '';
    };
    PluginResource.id = typings_1.PLUGIN_NAME.RESOURCE;
    return PluginResource;
}(basePlugin_1.default));
exports.PluginResource = PluginResource;
//# sourceMappingURL=resource.js.map